// Used to replace [VARIABLES] inside a template string.
// This is here for backwards compatibility
export const translateTemplate = (template, variables) => {
    if (!template) return ''

    const tokens = variableExtractor(template)

    return variableReplacer(template, tokens, variables)
}

// Returns an array of tokens in string
// Ex: [PHONE], [PRICE|bakflip-mx4-tonneau-cover]
export const variableExtractor = (template) => {
    // Earlyout if the template doesn't exist or if it doesn't contain any opening brackets
    if (!template?.includes('[')) return []

    return template.match(/\[[\sA-Za-z0-9_\-|]*\]/g) || []
}

// Replaces all the tokens in the template with the variables passed
export const variableReplacer = (template, tokens, variables) => {
    // Earlyout if the template doesn't exist or if it doesn't contain any opening brackets
    if (!template?.includes('[')) return template

    return tokens.reduce((acc, token) => {
        const formattedToken = token.slice(1, -1)
        acc = acc.replace(
            token,
            variables[formattedToken] !== undefined ? variables[formattedToken] : token
        )

        return acc
    }, template)
}
